module.exports = __webpack_public_path__ + "static/background-5add1413596f266d6d200c8bfc7c943c.jpg";